import React, { Component } from 'react';

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from 'recharts';
import ChartConfig, { tooltipStyle, tooltipTextStyle } from 'Constants/chart-config';
import canvg from 'canvg';

const data = [
    { name: 'A', value: 8, color: '#8884d8', fill: '#8884d8' },
    { name: 'B', value: 6, color: '#83a6ed', fill: '#83a6ed' },
    { name: 'C', value: 7, color: '#8dd1e1', fill: '#8dd1e1' },
    { name: 'D', value: 4, color: '#8dd1e1', fill: '#8884d8' },
  ];

  const CustomLegend = ({ payload }) => (
    <ul style={{ listStyle: 'none', margin:"0px", textAlign:"center" }}>
      {data.map((entry, index) => (
        <li key={`item-${index}`} style={{ display: 'inline-block', marginRight: 10 }}>
          <span style={{
            display: 'inline-block',
            width: 15,
            height: 10,
            marginRight:"3px",
            backgroundColor: entry.color
          }} />
          <span>{entry.name}</span>
        </li>
      ))}
    </ul>
  );

class SimpleBarChartComponent extends Component {

     
  render() {
    return (
      <ResponsiveContainer width={850} height={400}>
        <BarChart data={data}>
          <XAxis dataKey="name" stroke="green" interval={0} label={{stroke:"black"}} />
          <YAxis stroke={ChartConfig.axesColor} label={{ value: 'Weight (kg)', angle: -90, position: 'insideLeft' }}/>
          <CartesianGrid vertical={false} stroke="#ccc" />
          <Tooltip wrapperStyle={tooltipStyle} cursor={false} itemStyle={tooltipTextStyle} labelStyle={{ display: 'none' }} />
          <Legend content={<CustomLegend />} />
          <Bar dataKey="value" fill={(data) => data.color} label={{ fill :"#757474", position: "top" }} barSize={40} />
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

export default SimpleBarChartComponent;

